import { Pipe, PipeTransform } from '@angular/core';

import { Usuario } from '../usuario';

@Pipe({
    name: 'usuarioFilter',
    pure: false
})
export class UsuarioFilterPipe implements PipeTransform {
    transform(usuarios: Usuario[], value: string): any {
        if (!usuarios || !value || value.trim().length === 0) {
            return usuarios;
        }

        return usuarios.filter(usuario => usuario.nome ? usuario.nome.toUpperCase().includes(value.toUpperCase()) : false);
    }
}
